class AccountModel {
  constructor({ type = null, balances = {} } = {}) {
    this.type = type;
    this.balances = balances;
  }
  json() {
    return {
      type: this.type,
      balances: this.balances,
    };
  }
  list() {
    let ls = [];
    for (let account in this.balances) {
      ls.push({
        account: account,
        balance: this.balances[account].balance,
      });
    }
    return ls;
  }
}

module.exports = AccountModel;
